import { observer } from 'mobx-react';
import React from 'react';
import { EqualHeight, Heading, Separator, Text } from 'telia-front-react';
import { Package } from '../MobileBusinessInterfaces';
import PackageSelectionButton from './PackageSelectionButton';
import { TranslationsContext } from '@teliaee/telia-translate';
import PackagePrice from './PackagePrice';

interface Props {
  index: number;
  mobilePackage: Package;
}

@observer
class PackageCardHeaderContent extends React.Component<Props> {
  static contextType = TranslationsContext;
  declare context: React.ContextType<typeof TranslationsContext>;

  public render() {
    const { mobilePackage, index } = this.props;
    const { translate } = this.context;

    return (
      <Text>
        <Heading element="h3" className="h4">
          <span id={`card-title-${index}`} className="h2">
            {mobilePackage.capacity || translate('mobileBusiness.unlimited.card')}{' '}
            {mobilePackage.capacity && mobilePackage.capacityUnit ? translate(`mobileBusiness.capacityUnit.${mobilePackage.capacityUnit}`) : ''}
          </span>
        </Heading>
        <Separator spacing="xxsmall" color="invisible" />
        <span>{translate('mobileBusiness.capacitySpan')}</span>
        <EqualHeight group="price">
          <PackagePrice mobilePackage={mobilePackage} />
        </EqualHeight>
        <p className="text__margin-double">
          <PackageSelectionButton {...{ mobilePackage, index }} />
        </p>
      </Text>
    );
  }
}

export default PackageCardHeaderContent;
